import { eCommand, eDispatch } from './eCommand';

interface iResult<T> {
  code: number;
  msg: string;
  data: T;
}

interface iArea {
  id: number;
  name: string;
}

/**
 * 品牌
 */
interface iBrand {
  id: string;
  name: string;
}

interface iUserInfo {
  id: number;
  last_ip: string;
  token: string;
  username: string;
  role: string;
  app_ids?: Array<iBrand>;
  default_app_id?: string;
}

interface iPass {
  oldPass: string;
  pass: string;
  passAgain: string;
}

/**
 * 统计时长
 * */
interface iStatisticConfig {
  start: number;
  end: number;
  regionid?: number;
}

/**
 * 网吧详情
 * */
interface iStatisticDetail {
  start: number;
  end: number;
  areaid: number;
}

/**
 * 网吧信息(小区信息)
 */
interface iNetbar {
  id: number;
  name: string;
  area_name?: string;
  wan: string;
  isp: string;
  region_id: string;
  area_id?: string;
  addr: string;
  uplink: string;
  cmd_port: number;
  is_public: number;
  tcp_mode?: number;
  dispatch_type?: number;
  low_pool_id?: string;
  high_pool_id?: string;
  free_pool_id?: string;
  lux_pool_id?: string;
  port_mapping_prefix?: string;
}

/**
 * 列举设备
 */

interface iDevice {
  areaid?: number;
  area_id?: number;
  area_name?: string;
  config_id?: number;
  id?: number;
  ip?: number | string;
  mac?: string;
  mask?: string;
  port?: string;
  region_id?: number;
  region_name?: string;
  seq?: string;
  status?: number;
  status_desc?: string;
  editor?: boolean;
  cloud_id?: number;
  isp?: string;

  /**
   * 调度状态
   */
  dispath?: eDispatch;
  token?: string;
  tcp_mode?: number;
  uuid?: string;
  dispatch_type?: number;
  low_pool_id?: string;
  high_pool_id?: string;
  free_pool_id?: string;
  lux_pool_id?: string;
}
/**
 * 撤单明细
 */
interface iCancelDetail {
  cancel_at?: number;
  has_handle?: number;
  id?: number;
  last_ping?: number;
  mac?: string;
  machine_id?: number;
  nickname?: string;
  node_id?: string;
  node_name?: string;
  order_end?: number;
  order_start?: string;
  reason?: string;
  reason_code?: string;
  remark?: string;
  status?: number;
  uid?: number;
  game_name: string;
  qq_number: string;
  x_version: string;
  imgs: string[];
  deviceStatusName: string;
  feedback_type: number;
  gid: string;
}
interface _iDisplayKey {
  standard: number;
  advanced: number;
  total: number;
}

/**
 * 网吧概况
 */
export interface iStatisticArea {
  id: number;
  start: number;
  end: number;
  region_name: _iDisplayKey;
  netbar_name: _iDisplayKey;
}

/**
 * 网吧不同日期的数据
 */
export interface iNetbarDetail {
  date: number;
  total_length: number;
  advanced_length: number;
  standard_length: number;
  total_connect: number;
  advanced_connect: number;
  standard_connect: number;
}
/**
 * 终端调度的网吧列表信息返回值
 */
export interface iNetbarRes {
  id: number;
  /**
   * 专区名称
   */
  name: string;
  /**
   * 地区
   */
  city: string;
  /**
   * 地址
   */
  addr: string;
  /**
   * 联系人
   */
  person: string;
  /**
   * 电话
   */
  tel: string;
  /**
   * 云更新ID
   */
  cloud_id: number;
  /**
   * 外网ip
   */
  wan: string;
  /**
   * 运营商
   */
  isp: string;
  /**
   * 大区ID
   */
  region_id: number;
  /**
   * 大区名称
   */
  region_name: string;
  /**
   * 上行带宽
   */
  uplink: string;
  /**
   * 开关机端口
   */
  cmd_port: number;
  /**
   * 是否开放公网
   */
  is_public: boolean;
  /**
   * 编辑者
   */
  editor: boolean;
}

export interface iCommandOperate {
  /**
   * 某个操作行为
   */
  type: eCommand;
  /**
   * 绑定的id
   */
  id: number;
  seq: string;
}

export { iResult, iUserInfo, iNetbar, iDevice, iArea, iStatisticConfig, iStatisticDetail, iCancelDetail, iBrand };

export enum eDispatchType {
  /* 独立调度 */
  OWN_DISPACTH = 1,
  /* 共享调度 */
  PUBLIC_DISPACTH = 3,
  /* 统一调度 */
  UNIFY_DISPACTH = 2,
}

export enum eStatus {
  // 状态 -1=全部 0=空闲 1=使用,2=离线,3=故障 4-维护 5-使用（暂停分配）

  FREE = 0,
  USE = 1,
  OFFLINE = 2,
  MALFUCTIONED = 3,
  MAINTAIN = 4,
  USE_NO_ALLOT = 5,
  NO = -1,
}
